<div class="heading">Filters
    <i class="fa fa-times-circle fa-lg" id="closeimage" (click)="close()"></i>
</div>


<div *ngFor="let item of subjectWise; let i=index" class="add_grid">
    <div class="grid_one">
        <label for=""></label>
        <select class="cctv_size" id="" name="subjects{{i}}" [(ngModel)]="subjectWise[i].searchFilterDataKey"
            (change)="onSubjectSelect($event,i)">
            <option value="" selected disabled hidden>Select Column</option>
            <option *ngFor="let item of filterListDetails" value="{{item.filterDataMember}}"
                [disabled]="isColumnDisabled(item.filterDataMember)">{{item.filterDataValue}}</option>
        </select>
    </div>

    <div class="grid_two"> 
        <!--customized dropdown  -->
        <ng-container *ngIf="subjectWise[i].searchFilterDataKey !=='VISIT_DATE_TIME'">
            <div class="dropdown pt-2 pb-2 text-center"
            [ngStyle]="!subjectWise[i].searchFilterDataKey ? {'pointer-events': 'none', 'opacity': '0.6'} : {}">
                <a class="btn  dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false"
                    (click)="focusSearchInput(i)">
                    <ng-container>
                        <div class="sidebar">{{ subjectWise[i].searchFilterDataValues?.length ? subjectWise[i].searchFilterDataValues.join(', ') : 'Selected List' }}</div>
                    </ng-container>
                </a>
                <ul class="dropdown-menu campus-details" (click)="$event.stopPropagation()">
                    <li class="d-flex align-items-center">
                        <input type="text" class="form-control" placeholder="Search..." #searchInputcampus
                            (keyup)="campusSearch($event,i)" [(ngModel)]="campusQuery[i]" />
                    </li>
                    <li class="list_campus">
                        <label class="overall_Detail">
                            <input class="check_box" type="checkbox" [(ngModel)]="selectAll[i]"
                                (change)="toggleSelectAll(i)" />Select All
                        </label>
                        <ng-container *ngFor="let data of subjectWise[i].flt">
                            <label class="overall_Detail">
                                <input class="check_box" type="checkbox" [value]="data.userValue"
                                    [(ngModel)]="data.selected" (change)="onFacultySelect($event, i)"
                                    [checked]="subjectWise[i].flt?.includes(data.userValue)" />
                                <span class="campus_right">{{ data.userValue }}</span>
                            </label>
                        </ng-container>
                    </li>
                </ul>
            </div>
        </ng-container>

        <!-- VIST DATE TIME -->

        <ng-container *ngIf="subjectWise[i].searchFilterDataKey ==='VISIT_DATE_TIME'">
            <div class="dropdown pt-2 pb-2 text-center"
            [ngStyle]="!subjectWise[i].searchFilterDataKey ? {'pointer-events': 'none', 'opacity': '0.6'} : {}">
                <a class="btn  dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <ng-container  *ngIf="subjectWise[i].searchFilterDataKey ==='VISIT_DATE_TIME'">
                        <span class="sidebar">{{ subjectWise[i].searchFilterDataValues?.startDate && subjectWise[i].searchFilterDataValues?.endDate
                            ? subjectWise[i].searchFilterDataValues.startDate + ' To ' + subjectWise[i].searchFilterDataValues.endDate
                            : subjectWise[i].searchFilterDataValues?.rangeType
                              ? subjectWise[i].searchFilterDataValues?.rangeType
                              : 'Selected List'}}</span>
                    </ng-container> 
                 
                </a>
                <ul class="dropdown-menu campus-details" >
                    <div *ngFor="let option of radioOptions" class="form-check">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" [id]="option.id"
                            [value]="option.value" [(ngModel)]="selectedOption" (click)="onVistTimeRadio(option.value, i)" />
                        <label class="form-check-label" [for]="option.id" class="overall_Detail">
                            {{ option.label }}
                        </label>
                    </div>
                </ul>
            </div>
        </ng-container>

        <ng-container *ngIf="selectedOption ==='Custom_Range' && subjectWise[i].searchFilterDataKey ==='VISIT_DATE_TIME'">
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="Start date" [(ngModel)]="startDate" (dateChange)="onDateChange(i)">
                <input matEndDate placeholder="End date" [(ngModel)]="endDate" (dateChange)="onDateChange(i)">
              </mat-date-range-input>
              <mat-date-range-picker #picker></mat-date-range-picker>
        </ng-container>

    </div>

    <div class="grid_three">
        <button type="button" class="btn_delete text-danger remove_field"  *ngIf="(subjectWise.length -1)!==i" 
            (click)="deleteLowPerformanceFields(i)">
            <i class="fa fa-minus"></i>
        </button>
        <button type="button" class="add_btn add_field_button" *ngIf="(subjectWise.length -1)==i" [ngStyle]="!isAddEnabled(i) ? {'pointer-events': 'none', 'opacity': '0.6'} : {}"
            (click)="addSelected()" [disabled]="isRowEmpty(i)"  >
            <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
    </div>
    
</div>

<div class="submit">
    <button class="btn_close" (click)="closeFilter()">Close</button>
    <button class="apply" (click)="apply()">Apply</button>
</div>

<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>